import React from 'react';

// Shared visual building blocks for the student portal (client/src/pages/student/*),
// mirroring TrainerUI.jsx's icon-badged treatment — same color-mix(icon-on-tinted-
// circle) pattern as DashboardPage's StatCard. Only the icon glyph carries the
// accent color; readable text always stays on var(--sms-txt)/var(--sms-txt2), the
// palette's high-contrast tokens (documented ratios in index.css), so this stays
// WCAG AA-safe in both themes without re-deriving contrast per page.

// Icon-badged stat card for a stu-stat-row / stu-stat-row-4.
export function KpiCard({ label, value, icon, color, caption }) {
  return (
    <div className="stu-stat-card">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <span className="stu-stat-label" style={{ marginBottom: 0 }}>{label}</span>
        <div style={{ width: 30, height: 30, borderRadius: 8, background: `color-mix(in srgb, ${color} 12%, transparent)`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <i className={`bi ${icon}`} style={{ color, fontSize: 14 }} />
        </div>
      </div>
      <div className="stu-stat-value" style={{ marginTop: 0 }}>{value}</div>
      {caption && <div className="stu-stat-caption">{caption}</div>}
    </div>
  );
}

// Small icon-badge placed before a card's <h3> title.
export function SectionIcon({ icon, color }) {
  return (
    <span style={{
      width: 26, height: 26, borderRadius: 7, marginRight: 8, flexShrink: 0,
      background: `color-mix(in srgb, ${color} 12%, transparent)`,
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <i className={`bi ${icon}`} style={{ color, fontSize: 13 }} />
    </span>
  );
}
